import React from "react";

interface InputProps {
  placeholder: string;
  error?: boolean;
  value?: string;
  type?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  readOnly?: boolean;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({
  value = "",
  placeholder,
  error = false,
  type = "text",
  onChange,
  className,
  readOnly = false,
  startIcon,
  endIcon,
}) => {
  return (
    <div className="mb-4 w-full relative flex items-center">
      {startIcon && <div className="absolute left-3">{startIcon}</div>}
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={`w-full px-3 py-2 rounded-md border ${
          error ? "border-red-500" : "border-gray-300"
        } outline-none ${className}`}
        readOnly={readOnly}
        style={{
          paddingLeft: startIcon ? "2.5rem" : "0.75rem",
          paddingRight: endIcon ? "2.5rem" : "0.75rem",
        }}
      />
      {endIcon && <div className="absolute right-3">{endIcon}</div>}
    </div>
  );
};

export default Input;
